import axios from 'axios'
import router from '../router'

const mock = false;
/*axios.defaults.baseURL = 'localhost:3000';*/
console.log();
const service = axios.create({
    baseURL: mock?'/static/json/':process.env.API_HOST,  // api的base_url
    timeout: 5000000,  // 请求超时时间
    withCredentials: true
});
//const service = axios.create();

// http request 请求拦截器，有token值则配置上token值
service.interceptors.request.use(
    config => {
        return config;
    },
    err => {
        return Promise.reject(err);
    });
 
// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
service.interceptors.response.use(
    response => {

        if (response.data.redirect != null) {
            router.push('settingDays');
        }
        if(response.data == 'timeout'){
            router.replace({
                path: 'login'
            })
        }
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 这里写清除token的代码
                    router.replace({
                        path: 'login',
                        query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
                    })
            }
        }
        return Promise.reject(error) 
    });

export default service;



// WEBPACK FOOTER //
// ./src/util/http.js